import { useEffect } from "react";
import { supabase } from "./supabase";
import { useAsync } from "./supabaseHooks";
import { FaqsAPI, BlogsAPI } from "./supabaseServices";

/**
 * Realtime-aware FAQ hook. Subscribes to changes on the faqs table and refetches.
 */
export function useFaqsRealtime() {
  const state = useAsync(() => FaqsAPI.list(), []);
  useEffect(() => {
    const ch = supabase
      .channel("public-faqs")
      .on("postgres_changes", { event: "*", schema: "public", table: "faqs" }, () => state.refetch())
      .subscribe();
    return () => {
      supabase.removeChannel(ch);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return state;
}

/**
 * Realtime-aware Blogs hook. Subscribes to changes on the blogs table and refetches.
 */
export function useBlogsRealtime(opts = {}) {
  const state = useAsync(() => BlogsAPI.list(opts), [JSON.stringify(opts)]);
  useEffect(() => {
    const ch = supabase
      .channel("public-blogs-hook")
      .on("postgres_changes", { event: "*", schema: "public", table: "blogs" }, () => state.refetch())
      .subscribe();
    return () => {
      supabase.removeChannel(ch);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(opts)]);
  return state;
}
